import * as React from 'react';
import {FunctionComponent} from 'react';
import {Part, PartType} from '../../models/Part';
import {formatDurationMs} from '../formatting/format_duration';
import {formatDistanceMeters} from '../formatting/format_distance';
import {DeviceName, listDevices, toHumanReadableDeviceName} from '../../models/DeviceName';

interface OwnProps {
    part: Part;
    height?: number;
    onMainDeviceChange?: (deviceName: DeviceName | null) => void;
}

interface ContainerOwnProps {
    height?: number;
}

const Container: FunctionComponent<ContainerOwnProps> = ({children, height}) => {
    const minHeight = height ? (height < 60 ? 60 : height) : undefined;
    return (
        <div className="part" style={{minHeight: minHeight}}>
            <div className="part__details">{children}</div>
        </div>
    );
};

export const PartComponent: FunctionComponent<OwnProps> = ({part, height, onMainDeviceChange, children}) => {
    const select = onMainDeviceChange ? (
        <select
            className="form-control part__select"
            value={part.device_identifier || ''}
            onChange={(e) => {
                const deviceName = e.target.value === '' ? null : e.target.value;
                onMainDeviceChange(deviceName as DeviceName | null);
            }}
        >
            <option>None</option>
            {listDevices().map((device) => (
                <option key={device.id} value={device.id}>
                    {device.name}
                </option>
            ))}
        </select>
    ) : (
        part.device_identifier && (
            <span className="part__device">{toHumanReadableDeviceName(part.device_identifier)}</span>
        )
    );

    switch (part.type) {
        case PartType.Distance:
            return (
                <Container height={height}>
                    <div className="part__icon">
                        <img src="/images/icons/distance.svg" />
                    </div>
                    <div className="part__type">Distance</div>
                    <div className="part__value">
                        {formatDistanceMeters(part.distance_meters)}
                        {select}
                    </div>

                    <div className="part__content">{children}</div>
                </Container>
            );
        case PartType.Duration:
            return (
                <Container height={height}>
                    <div className="part__icon">
                        <img src="/images/icons/duration.svg" />
                    </div>
                    <div className="part__type">Duration</div>
                    <div className="part__value">
                        {formatDurationMs(part.duration_milliseconds)}
                        {select}
                    </div>
                    <div className="part__content">{children}</div>
                </Container>
            );
        case PartType.Repetitions:
            return (
                <Container height={height}>
                    <div className="part__icon">
                        <img src="/images/icons/repetitions.svg" />
                    </div>
                    <div className="part__type">Repetitions</div>
                    <div className="part__value">
                        {part.repetitions}
                        {select}
                    </div>
                    <div className="part__content">{children}</div>
                </Container>
            );
        case PartType.Rest:
            return (
                <Container height={height}>
                    <div className="part__icon">
                        <img src="/images/icons/rest.svg" />
                    </div>
                    <div className="part__type">Duration</div>
                    <div className="part__value">
                        {formatDurationMs(part.rest_milliseconds)}
                        {select}
                    </div>
                    <div className="part__content">{children}</div>
                </Container>
            );
        case PartType.OffErg:
            return (
                <Container height={height}>
                    <div className="part__icon">
                        <img src="/images/icons/off_erg.svg" />
                    </div>
                    <div className="part__type">Off erg</div>
                    <div className="part__value">
                        {formatDurationMs(part.duration_milliseconds)}
                        {select}
                        &nbsp;{part.instruction_text}
                    </div>
                    <div className="part__content">{children}</div>
                </Container>
            );
    }
};
